import { gql, useQuery } from 'modules/GraphQL';
import DataResponseContainer from 'modules/common/components/DataResponseContainer';
import React from 'react';
import MemberDetails, { MemberDetailsProps } from '../components/MemberDetails';

const DETAILS = gql`
  query member($_id: ID!) {
    member(_id: $_id) {
      code
      error
      success
      item {
        _id
        name
        image
        email
        title
        url
        bio
        phone
        companyLocation
        sector
        companyArea
        companySalaryTreated {
          min
          max
        }
        companyClients
        companySize
        businessRegistrationId
        behaviorGuidelines
        nbAvailableProfiles
        nbAvailableProfilesPublished
        nbSearchedProfiles
        nbSearchedProfilesPublished
        nbContactsProspecting
        nbContactsSourcing
        nbQualityContactsProspecting
        nbQualityContactsSourcing
        createdAt
        updatedAt
        lastLoginAt
        onHolidaysUntil
        onHolidays
      }
    }
  }
`;

const Member: React.FC<Omit<MemberDetailsProps, 'member'> & { _id: string }> = ({ _id, onSubmit, ...props }) => {
  const { loading, data } = useQuery(DETAILS, { variables: { _id } });

  const item = data?.member?.item;

  return (
    <DataResponseContainer data={data} loading={loading}>
      <MemberDetails member={item} {...props} />
    </DataResponseContainer>
  );
};

export default Member;
